var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "b-modal",
        {
          attrs: {
            "button-size": "sm",
            size: "lg",
            title: "Images",
            centered: true,
            "footer-class": "p-2 border-top-0",
            "header-class": "p-2 border-bottom-0",
            "header-bg-variant": "primary",
            "header-text-variant": "white",
            "header-close-variant": "white",
            "hide-header-close": true,
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "modal-footer",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [_vm._v("\n      Close\n    ")]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            3969378815
          ),
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "text-center text-success my-2" },
                [
                  _c("b-spinner", {
                    staticClass: "align-middle mr-2",
                    attrs: { size: "lg" },
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Loading...")]),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "d-flex flex-wrap  justify-content-center",
                  staticStyle: { gap: "10px" },
                },
                _vm._l(_vm.images, function (image) {
                  return _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/api/actions/" + _vm.actionId + "/images/" + image,
                        target: "_blank",
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          src:
                            "/api/actions/" + _vm.actionId + "/images/" + image,
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }